import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {RouteUtils} from '@application/helper/routing/route-utils';
import {Permission} from '@domain/profile/permission.enum';
import {Subscription} from '@domain/profile/subscription';
import {AUTHENTICATION} from '@infrastructure/http/authentication/authentication';
import {DRAWINGS} from '@infrastructure/http/drawing/drawings';
import {MACHINE_OVERVIEW} from '@infrastructure/http/machine-overview/machine-overview';
import {isNil} from 'lodash-es';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

export const canActivateSettingsGuard = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean => {
  const drawingLibraryUrl = RouteUtils.paths.texEdit.designLibrary.absolutePath;
  const machineOverviewUrl = RouteUtils.paths.texState.absolutePath;
  const settingsUrl = '/settings';
  const router = inject(Router);
  const authentication = inject(AUTHENTICATION);

  const currentSubscription: Subscription = authentication.getCurrentSubscription();
  const requiredPermission: Permission = route.data.permissionToCheckSettings;
  let service;

  if (state.url === drawingLibraryUrl) {
    service = inject(DRAWINGS);
  } else if (state.url === machineOverviewUrl) {
    service = inject(MACHINE_OVERVIEW);
  }

  if (!isNil(service) && currentSubscription.hasPermission(requiredPermission)) {
    return service.hasAlreadyAdjustedCustomSettings().pipe(
      map((alreadyAdjustedCustomSettings: boolean) => {
        if (!alreadyAdjustedCustomSettings) {
          router.navigateByUrl(`${state.url}${settingsUrl}`);
        }
        return alreadyAdjustedCustomSettings;
      })
    );
  } else {
    return true;
  }
};
